module.exports = __webpack_public_path__ + "static/media/topic.095ed0fe.png";